module.exports = __webpack_public_path__ + "static/img/newCity.9cc4effa.png";